module.exports = "<app-view></app-view>\r\n\r\n<router-outlet></router-outlet>\r\n"